export default __webpack_public_path__ + "static/media/siemens.de8fa609.png";